module.exports = "//web.yystatic.com/project/yycom_header/pc/images/default_portrait-e5a8ab93.jpg";